import { mapActions, mapGetters } from 'vuex'
import { PROFILE_INFO } from '@javascript/config/routes'
export default {
  inject: ['locale', 'defaultLocale', 'baseUrlWithLocale'],
  data: () => ({
    pathName: '',
  }),
  methods: {
    ...mapActions({
      API_PROFILE_MENU: 'navigation/API_PROFILE_MENU',
    }),
    async getNavigationItems() {
      let locale = this.getLocaleForApi()
      await this.API_PROFILE_MENU({
        key: 'profile_info',
        locale: locale,
      })
    },
    getLocaleForApi() {
      return this.locale === this.defaultLocale ? null : this.locale
    },
    setNaviationPathName() {
      this.pathName = window.location.pathname
    },
  },
  computed: {
    ...mapGetters({
      navigationItems: 'navigation/getProfileMenu',
    }),
    visibleMenu() {
      return !!this.navigationItems && !!this.navigationItems.length
    },
    initialItem() {
      let initialItem = null,
        defaultInitialItem = null
      this.navigationItems.forEach((element) => {
        if (element.url.includes(PROFILE_INFO)) {
          defaultInitialItem = element
        }
        if (element.url == this.pathName) {
          initialItem = element
        }
      })
      return initialItem || defaultInitialItem
    },
  },
  created() {
    this.setNaviationPathName()
    this.getNavigationItems()
  },
}
